import { useRouter } from 'next/router'

import AuthConfirmPassword from '@/components/auth/screens/AuthConfirmPassword'
import Button from '@/components/shared/ui/Button'
import UnstyledLink from '@/components/shared/ui/Links/UnstyledLink'
import Typography from '@/components/shared/ui/Typography'
import { signinPath } from '@/lib/helpers/pathHelpers'

export default function UserConfirmationPage() {
  const router = useRouter()
  const { confirmation_token } = router.query as { confirmation_token: string }

  if (confirmation_token) {
    return (
      <div className='mx-auto max-w-5xl'>
        <section className='mx-auto max-w-sm p-5'>
          <h1 className='text-2xl font-bold tracking-tight'>
            Confirm your Password
          </h1>
          <AuthConfirmPassword confirmationToken={confirmation_token} />
        </section>
      </div>
    )
  }

  return (
    <div className='mx-auto max-w-5xl'>
      <section className='mx-auto max-w-sm p-5'>
        <h1 className='text-2xl font-bold tracking-tight'>
          Reset your Password
        </h1>
        <div className='mb-3 mt-2 text-gray8'>
          <Typography.Text className='mb-3 mt-2 text-gray8'>
            Invalid or expired token
          </Typography.Text>
          <div>
            <UnstyledLink href={signinPath} className='mt-5'>
              <Button>Sign in</Button>
            </UnstyledLink>
          </div>
        </div>
      </section>
    </div>
  )
}
